import { render, staticRenderFns } from "./Password_forgot.vue?vue&type=template&id=007a9d63&scoped=true&"
import script from "./Password_forgot.vue?vue&type=script&lang=js&"
export * from "./Password_forgot.vue?vue&type=script&lang=js&"
import style0 from "./Password_forgot.vue?vue&type=style&index=0&id=007a9d63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a9d63",
  null
  
)

export default component.exports